<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <h4>{{ $t("messages.clearDataReqEnroll.title") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row> </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.academicYear") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.semester") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 60%; justify-content: center;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="handleClearpreregdata()"
                      >
                        {{ $t("messages.general.clearData") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="saveInfomation()"
                      >
                        {{ $t("messages.general.saveInformation") }}</button
                      >&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
          <v-card tile>
            <v-toolbar flat dense color="light-green accent-3">
              <v-icon color="light-green darken-2">fa-check</v-icon>
              <v-toolbar-title style="color: green;"
                >&nbsp;{{
                  $t("messages.reqRegister.confirmPopupText")
                }}</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
              <v-toolbar-items>
                <v-btn icon @click="dialogConfirmSuccess = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text dark color="green accent-1">
              <br />
              <span v-html="successText" style="color: green;">{{
                successText
              }}</span>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogError" max-width="600px">
          <v-card tile>
            <v-toolbar flat dense color="red darken-3">
              <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
              <v-toolbar-title style="color: #ffebee;"
                >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
              <v-toolbar-items>
                <v-btn icon @click="dialogError = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text dark color="red accent-1">
              <br />
              <span style="color: red;" v-html="errorText">{{
                errorText
              }}</span>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import EnrollProvider from "@/services/enroll_provider";
import MasterDataProvider from "@/services/masterData_provider";

// eslint-disable-next-line no-unused-vars
const masterDataProvider = new MasterDataProvider();
// eslint-disable-next-line no-unused-vars
const enrollProvider = new EnrollProvider();

export default {
  name: "cancelReqEnrollment",
  components: {
    AcademicYear,
    Semester,
  },
  data() {
    return {
      selectedDetail: false,
      selYear: 0,
      selSemester: 0,
      studentList: [],
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      searchSelIdx: 0,
      selectedStudentIdx: 0,
      selectedStudent: false,
      selectedStudentData: [],
      programs: [],
      infoFormStatus: 2,
      regStatus: 0,
      programSelIdx: 0,
      selectedYear: 0,
      selectedYearOpts: [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
      ],
      selItem: 0,
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selYearProgram = this.appInfo.data.ENROLL_ACADYEAR;
    this.selItem = 0;
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", [
      "togglePreLoader",
      "tokenHealthChk",
      "setStudentInfo",
    ]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    async handleClearpreregdata() {
      this.togglePreLoader(true);
      const res = await enrollProvider.deleteClearpreregdata({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          lang: this.currentLang,
        },
      });
      this.togglePreLoader(false);
      if (res.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${res.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${res.message}<br/>`;
      }
    },
    async saveInfomation() {
      this.togglePreLoader(true);
      const temp = {
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          lang: this.currentLang,
        },
      };
      const result = await enrollProvider.postClearpreregdata(temp);
      this.togglePreLoader(false);

      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
    },

  },
  watch: {
    async currentLang() {
      await this.handleSearchStudent();
      this.selectedYearOpts = [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
      ];
    },
  },
};
</script>
